'use client';

import React from 'react';
import useFilterSets from 'src/hooks/filters/useFilterSets';
import { FilterSet } from 'src/context/reducers/filterSetReducer';

interface ClearFilterButtonProps {
  type: keyof FilterSet;
  isDisabled?: boolean;
  location: string;
}

const ClearFilterButton = ({
  type,
  isDisabled = false,
  location,
}: ClearFilterButtonProps) => {
  const { clearFilter } = useFilterSets(location);

  const handleClearFilter = () => {
    clearFilter(type);
  };

  return (
    <div
      className={`justify-start text-tertiary text-xs font-normal
                    font-['Inter'] leading-tight
                    ${
                      isDisabled
                        ? 'opacity-50 pointer-events-none'
                        : 'opacity-100 hover:text-neutral-600 cursor-pointer'
                    }
                    `}
      onClick={isDisabled ? null : () => handleClearFilter()}
    >
      Clear
    </div>
  );
};

export default ClearFilterButton;
